/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import Object from 'apmui/util/Object';
import { HTTPError } from 'apmui/util/request';

enum VdiErrorType {
    UNSPECIFIED = 'Unspecified',
    LOGON_FAILED = 'LogonFailed',
    SERVER_BUSY = 'ServerBusy',
    NO_RESOURCES = 'NoResources',
    APP_LAUNCH = 'AppLaunch',
    AUTO_LAUNCH_IE = 'AutoLaunchIE',
}

/* eslint-disable @typescript-eslint/no-namespace, no-inner-declarations */
namespace VdiErrorType {
    export function isInstance(err: any): err is VdiErrorType {
        return Object.values(VdiErrorType).indexOf(err) >= 0;
    }
    export function fromError(err?: Error): VdiErrorType {
        if (err instanceof HTTPError) {
            switch ((err as HTTPError).code) {
                case 403:
                    return VdiErrorType.LOGON_FAILED;
                case 503:
                    return VdiErrorType.SERVER_BUSY;
                default:
                    /*
                     * VDI plugin returns error 500 in case of certain issues with credentials, including
                     *  - missing credentials for resource
                     *  - any abnormal behavior of RDP host
                     * Handle all unknown HTTP errors as LOGON_FAILED
                     */
                    return VdiErrorType.LOGON_FAILED;
            }
        }
        /* Wrapped error support: new Error(VdiErrorType.SOMETHING) */
        if (err && isInstance(err.message)) {
            return err.message as VdiErrorType;
        }
        return VdiErrorType.UNSPECIFIED;
    }
}

class VdiError extends Error {
    detail: any;
    constructor(err: VdiErrorType | Error, detail?: any) {
        super(VdiErrorType.isInstance(err) ? err : VdiErrorType.fromError(err));
        this.detail = detail;
    }
}

export { VdiError, VdiError as default, VdiErrorType };
